import { StorageId } from '../types/StorageId';

const getToken = () => localStorage.getItem(StorageId.IdToken);

export const getHeaders = () =>
  new Headers({
    Authorization: `Bearer ${getToken()}`,
    'Content-Type': 'application/json',
  });
